import H from 'constants/httpMethod.const';
import UMSG_TYPE from 'constants/umsg/type.const';
import fromDtosToStylists from 'dto/stylist/fromDtosToStylists.dto';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

// noinspection JSUnusedLocalSymbols
const reconfigure = (config) => (options, extra) => ({
  ...options,
  ...config,
  fromDto: fromDtosToStylists,
  umsg: UMSG_TYPE.global,
});

export const abeStylists = actionEndpointBe('abeStylists', H.get, 'salon/:salonId/stylist/', reconfigure({ inert: false }));

export const ibeStylists = actionEndpointBe('ibeStylists', H.get, 'salon/:salonId/stylist/', reconfigure({ inert: true }));
